/**
 * Review Archetype
 * 
 * @version 1.2
 * @author Daniel Lepe
 * Agregada la opción de pase de getArgs en alta de definición.
 * 
 * @author Daniel Lepe
 * Agregada la función quicktableFilters y archetypeReviewCFG, útiles para filtar en quicktable y 
 * agregar dependencias de configuración Review => Review_hijo respectivamente.
 * @date [date]
 * @version 1.1
 * 
 * @author Daniel Lepe
 * @date [date]
 * @version 1.0
 */

import _ from 'lodash'
import Vue from 'vue'
import {objectToUrlString} from '@/utils.js'

const reviewRates = [
    { key: '5-excelente', textClass: 'text-success', label: 'Excelente' },
    { key: '3-meh', textClass: 'text-warning', label: 'Regular' },
    { key: '0-malo', textClass: 'text-danger', label: 'Malo' },
];

const reviewRatesFilter = (value) => {
    const rate = reviewRates.find(r => r.key === value);
    return rate ? rate.label : value;
}

const reviewRatesTextClass = (value) => {
    const rate = reviewRates.find(r => r.key === value);
    return rate ? rate.textClass : '';
}

Vue.filter('reviewRatesFilter', reviewRatesFilter);
Vue.filter('reviewRatesTextClass', reviewRatesTextClass);

const baseController = 'Review',
    baseIndex = baseController + '/index',
    archetype = () => {
        return [
            {
                key: 'id',
                type: 'hidden'
            },
            // {
            //     key: 'usuario_id',
            //     label: 'Usuario',
            //     type: 'number'
            // },
            // {
            //     key: 'encabezado_id_pk',
            //     label: 'Encabezado',
            //     type: 'number'
            // },
            // {
            //     key: 'admin_view',
            //     label: 'Vista de administrador',
            //     type: 'number'
            // },
            // [
            {
                key: 'platillo',
                readonly: true,
            },
            {
                key: 'nombre_completo',
                label: 'Reseñado por...',
                readonly: true,
            },
            [
                {
                    key: 'fecha',
                    label: 'Fecha',
                    type: 'date',
                    readonly: true
                },
                {
                    key: 'calificacion',
                    label: 'Calificación',
                    type: 'select',
                    options: [
                        ...reviewRates.map(rate => ({ value: rate.key, text: rate.label }))
                    ],
                    readonly: true
                },
            ],
            // ],
            null,
            {
                key: 'comentarios',
                label: 'Comentario',
                type: 'textarea',
                readonly: true
            },
            null,
            [
                {
                    key: 'created',
                    label: 'Creado',
                    readonly: true
                },
                {
                    key: 'modified',
                    label: 'Modificado',
                    readonly: true
                },
            ],
        ]
    },
    captions = [
        { key: 'platillo', label: 'Platillo', stickyColumn: true, sortable: true },
        { key: 'fecha', label: 'Fecha de preparación', sortable: true },
        { key: 'nombre_completo', label: 'Usuario', sortable: true },
        // { key: 'created', label: 'Fecha y hora de reseña', sortable: true },
        // { key: 'modified', label: 'Modificado' },
        { key: 'calificacion', label: 'Calificación', sortable: true },
        { key: 'comentarios', label: 'Comentario', sortable: true },
        { key: '_' }
        // { key: 'admin_view', label: 'Vista de administrador' },
    ],
    quicktableFilters = () => {
        const calificacionFilter = {
            key: 'calificacion',
            label: 'Calificación',
            required: true,
            options: [
                { key: '@', label: 'Todos' },
                ...reviewRates
            ],
            default: null
        };
        const fechaFilter = {
            key: 'fecha',
            label: 'Fecha de preparación',
            required: true,
            type: 'date',
            default: 'today'
        };

        return [
            calificacionFilter,
            fechaFilter
        ]
    },
    archetypeReviewCFG = () => {
        return [
            // { key: 'id', type: 'hidden' },
            // { key: 'Review_id', type: 'hidden', },
            // { key: 'descriptor', label: 'Description', readonly: true },
        ]
    };

let automodalHandler = (conceptId, args = {}) => {
    let str = baseController + '/define/' + ((_.isNil(conceptId)) ? 'null' : (conceptId));
    str += '/' + objectToUrlString(args);
    return str;
}

export {
    captions,
    baseIndex,
    archetype,
    archetypeReviewCFG, 
    quicktableFilters,
    automodalHandler,
    reviewRatesFilter
}